// let base = "https://admin.inovacetech.com/inovace-admin/api/v1/"
// let base = "http://test.admin.inovacetech.com/inovace-admin/api/v1/"
// let base = "http://127.0.0.1:8081/inovace-admin/api/v1/"
let base = window.location.origin + "/inovace-admin/api/v1/";
if(window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1") base = "http://127.0.0.1:8081/inovace-admin/api/v1/";
export const API = {
	analytics: {
		summary: base + "dashboard/analytics/summary",
	},
	issues: {
		summary:      base + "dashboard/issues/summary",
		list:         base + "dashboard/issues",
		detail:       function(id) { return base + "dashboard/issues/" + id; },
		updateStatus: function(id) { return base + "dashboard/issues/" + id + "/status"; },
		assign:       function(id) { return base + "dashboard/issues/" + id + "/assign"; },
		comments:     function(id) { return base + "dashboard/issues/" + id + "/comments"; },
	},
	teamMembers: {
		list:         base + "dashboard/team-members",
		detail:       function(id) { return base + "dashboard/team-members/" + id; },
		deactivate:   function(id) { return base + "dashboard/team-members/" + id + "/deactivate"; },
		activate:     function(id) { return base + "dashboard/team-members/" + id + "/activate"; },
	},
	issueConfig: {
		servers:      base + "dashboard/issue-config/servers",
	},
	downtime: {
		summary:      base + "dashboard/downtime/summary",
		live:         base + "dashboard/downtime/live",
		reports:      base + "dashboard/downtime/reports",
		entry:        base + "dashboard/downtime/entry",
		recentManual: base + "dashboard/downtime/entry/recent",
	},
	monitoring: {
		live:    base + "monitoring/live",
		trend:   base + "monitoring/trend",
		summary: base + "monitoring/summary",
		systems: base + "monitoring/systems",
		system:  function(id) { return base + "monitoring/systems/" + id; },
	},
	auth: {
		signIn: base + "auth/signin"
	},
	version: {
		versionList: base + "version/list",
		versionNameList: base + "version/list/names",
		versionConfigure: base + "version/add-module"
	},
	modules: {
		moduleList: base + "module/list",
		moduleStore: base + "module"
	},
	subscriptions: {
		all: base + "subscription/all/",
		subscriptionPeriodList: base + "subscription/periods/",
		paymentOptionList: base + "subscription/payment-options/",
		pricingOptionList: base + "subscription/pricing-options/",
		subscribe: base + "subscription/subscribe/",
		delete: base + "subscription/delete/",
		update: base + "subscription/edit/",
		expired: base + "subscription/expired/",
		requestList: base + "subscription/request-list",
		excelExport: base + "subscription/request-list/export",
	},
	office: {
		officeList: base + "office/",
		officeListForPF: base + "office/payroll/",
		create: base + "office/create",
		getByProjectIdList: base + "office/by-project-id-list",
		updateModule: "/update-module",
		sendPayrollActivationEmail : base + "office/send-payroll-activation-mail",
		deviceList: base + "office/devices/all/",
		billingItems: base + "office/billing-items"
	},
	officePfConfig:{
		getOfficePfConfigByOfficeId: base + "office-pf-config/office/",
		saveOfficePfConfig: base + "office-pf-config/save",
	},
	company: {
		companyList: base + "company/",
		create: base + "company/create",
		update: base + "company/update/"
	},
	invoice: {
		unpaid                : base + "invoices/unpaid/",
		unpaidNonPaginated    : base + "invoices/unpaid/non-paginated",
		unapproved            : base + "invoices/unapproved/",
		approved              : base + "invoices/approved/",
		approve               : base + "invoices/approve/",
		edit               : base + "invoices/update-invoice/",
		invoiceListOfAProject : base + "invoices/",
		download							: base + "invoices/download/"
	},
	payment: {
		historyList: {
			all: base + "payment-history/all/",
			invoice: base + "payment-history/invoice/"
		},
		create: base + "payment-history/create/",
		verify: base + "payment-history/verify/",
		downloadInvoice : base + "payment-history/download-invoice/"
	},
	onboarding: {
		client: base + "onboarding/client",
		emailAvailable: base + "onboarding/email-available"
	},
	pay: {
		summary: base + "pay/summary",
		clients: base + "pay/clients"
	},
	customer: {
		all: base + "customer/list",
		projectNames: base + "customer/project-names",
		updateCustomer : base + "customer/",
		updateApiAccess : base + "customer/enableAccess/",
		generateApiToken : base + "customer/api-token/",
		mailApiToken : base + "customer/api-token/mail/",
		createProject : base + "customer/create-project",
		projectDeviceList : base + "customer/devices/",
		assignSupportEmployee : base + "customer/support/assign",
		getAvailableSupportEmployees : base + "customer/support/available-employees",
		getAllCustomerSupportDetails : base + "customer/support/details",
		cloneTemporaryAllocations : base + "customer/support/temporary-allocations/clone",
		downloadArchivedReport : base + "customer/support/archived-report/download",
	},
	employee:{
		all: base + "employee/",
		employeeList : base + "employee/all-employees/",
		updateManagerOrApproverConfig : base + "employee/update-config/",
		setEmployeeRole : base + "employee/set-role/",
		existingPayrollStaff: base + "employee/payroll-staffs/",
		removePayrollStaff: base + "employee/remove-payroll-staff/"
	},
	reseller: {
		all: base + "resellers/",
		stock: base + "resellers/stock/"
	},
	companyGroup    : {
		all: base + "company-groups/",
		create: base + "company-groups/create",
		update:  base + "company-groups/update/",
	},
	purchaseOrder   : {
		all: base + "purchase-orders/",
		create: base + "purchase-orders/create",
		undelivered: base + "purchase-orders/undelivered",
		delivered: base + "purchase-orders/delivered",
		update: base + "purchase-orders/update/",
		exportAsExcel: base + "purchase-orders/export-excel"
	},
	deliveryDetails : {
		all                     : base + "delivery-details/",
		create                  : base + "delivery-details/create",
		replace                 : base + "delivery-details/replace",
		getByPurchaseOrderId    : base + "delivery-details/all-devices?purchaseOrderId=",
		downloadDeliveryReceipt : base + "delivery-details/download-delivery-receipt/",
		update                  : base + "delivery-details/update/"
	},
	generalSettings : {
		all	: base + "general-settings/",
		parking : base + "general-settings/dummy/parking-management",
		membership : base + "general-settings/dummy/membership-management",
		site : base + "general-settings/dummy/site-management",
		deviceAndEmployeeLimit : base + "general-settings/employee-and-device-limit",
	},
	department : {
		all : base + "department/"
	},
	salesChannel: {
		all: base + "sales-channels/"
	},
	// Application Logs. File names travel as the `file` query parameter, never in the path:
	// Spring truncates a trailing ".log" out of a path variable and Tomcat rejects encoded
	// slashes outright.
	logs: {
		sources   : base + "logs/sources",
		allSources: base + "logs/sources/all",
		validate  : base + "logs/sources/validate",
		audit     : base + "logs/audit",
		source    : function(id)   { return base + "logs/sources/" + id; },
		files     : function(code) { return base + "logs/sources/" + code + "/files"; },
		tail      : function(code) { return base + "logs/sources/" + code + "/tail"; },
		content   : function(code) { return base + "logs/sources/" + code + "/content"; },
		search    : function(code) { return base + "logs/sources/" + code + "/search"; },
		download  : function(code) { return base + "logs/sources/" + code + "/download"; }
	}
};

